/* eslint-disable @typescript-eslint/no-explicit-any */
class Storage {
  set = (key: string, data: any) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(data));
    }
  };

  get = (key: string): any => {
    if (typeof localStorage !== 'undefined') {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    }
    return null;
  };

  remove = (key: string) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(key);
    }
  };

  clear = () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.clear();
    }
  };

  upsert = (key: string, data: any) => {
    if (typeof localStorage !== 'undefined') {
      const existing = this.get(key);
      this.set(key, { ...existing, ...data });
    }
  };
}

const storage = new Storage();

export default storage;

